import {
  MenuItem,
  Menu,
  MenuButton,
  MenuList,
  Button,
  RevertIcon,
  ChevronDownIcon,
} from '@cdl/heartbeat-react';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetEcg } from '../../../ecg/clients/ecg.client';
import * as clusterActions from '../../actions/cluster.actions';
import * as layoutActions from '../../../layout/actions/layout.actions';
import { getLayoutMock } from '../../../../tests/mocks/layout.mock';

interface Props {
  ecgId: string;
}
export const ResetButton: React.FC<Props> = ({ ecgId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetAnnotation = useCallback(async () => {
    const hasReset = await resetEcg(ecgId);
    if (hasReset) {
      dispatch(layoutActions.update({ update: getLayoutMock() }));
      await dispatch(clusterActions.cleanUp());
      navigate(`/${ecgId}/clustering/`);
    }
  }, [dispatch, navigate, ecgId]);

  return (
    <Menu>
      <MenuButton as={Button} borderLeftRadius={0} px='xs' size='xs'>
        <ChevronDownIcon />
      </MenuButton>
      <MenuList minWidth='unset'>
        <MenuItem onClick={resetAnnotation}>
          <RevertIcon mr='s' />
          Reset analysis to initial state
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
